import delivery1 from './delivery1.jpg'
import delivery2 from './delivery2.jpg'

export { delivery1, delivery2 }


// WEBPACK FOOTER //
// ./src/components/Delivery/images/index.js